module.exports = __webpack_public_path__ + "img/0Q3B1891_L_BlackMatted_MockedUp.f9efeb7d.jpg";